"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpErrorResponse = exports.ActiveInsurance = exports.SuccessStatus = exports.Insurance = exports.InsuranceTier = exports.Deductibles = exports.InsuranceDeductible = exports.PersonalInfo = exports.billingAddress = exports.TokenResponse = exports.transformDeductibles = exports.InsuranceTypeNames = exports.InsuranceType = void 0;
var InsuranceType;
(function (InsuranceType) {
    InsuranceType["Standard"] = "STANDARD";
    InsuranceType["AppleCareServices"] = "ACS";
    InsuranceType["HomeProtection"] = "HOME_PROTECTION";
    InsuranceType["phoneInsuranceCsn"] = "TECH_PROTECTION";
})(InsuranceType = exports.InsuranceType || (exports.InsuranceType = {}));
exports.InsuranceTypeNames = new Map([[InsuranceType.Standard, 'Wireless Protection Plan'],
    [InsuranceType.AppleCareServices, 'Wireless Protection with AppleCare Services']]);
function transformDeductibles(decuctibles) {
    const insuranceDeductibles = {};
    decuctibles.forEach((deductible) => {
        switch (deductible.deductibleName) {
            case 'IN_STORE_SCREEN':
                insuranceDeductibles.inStoreScreen = deductible.deductiblePrice;
                break;
            case 'WEB_SCREEN':
                insuranceDeductibles.webScreen = deductible.deductiblePrice;
                break;
            case 'LOST_STOLEN':
                insuranceDeductibles.lostOrStolen = deductible.deductiblePrice;
                break;
            case 'DEFAULT':
                insuranceDeductibles.default = deductible.deductiblePrice;
                break;
        }
    });
    return insuranceDeductibles;
}
exports.transformDeductibles = transformDeductibles;
class TokenResponse {
}
exports.TokenResponse = TokenResponse;
class billingAddress {
}
exports.billingAddress = billingAddress;
class PersonalInfo {
}
exports.PersonalInfo = PersonalInfo;
// Insurance Deductible
var InsuranceDeductible;
(function (InsuranceDeductible) {
    InsuranceDeductible["DEFAULT"] = "DEFAULT";
    InsuranceDeductible["LOST_STOLEN"] = "LOST_STOLEN";
    InsuranceDeductible["WEB_SCREEN"] = "WEB_SCREEN";
    InsuranceDeductible["IN_STORE_SCREEN"] = "IN_STORE_SCREEN";
})(InsuranceDeductible = exports.InsuranceDeductible || (exports.InsuranceDeductible = {}));
class Deductibles {
}
exports.Deductibles = Deductibles;
class InsuranceTier {
}
exports.InsuranceTier = InsuranceTier;
class Insurance {
}
exports.Insurance = Insurance;
class SuccessStatus {
}
exports.SuccessStatus = SuccessStatus;
class ActiveInsurance {
}
exports.ActiveInsurance = ActiveInsurance;
class HttpErrorResponse {
}
exports.HttpErrorResponse = HttpErrorResponse;
//# sourceMappingURL=interfaces.component.js.map